export var Day;
(function (Day) {
    Day["Mon"] = "Mon";
    Day["Tue"] = "Tue";
    Day["Wed"] = "Web";
    Day["Thu"] = "Thu";
    Day["Fri"] = "Fri";
    Day["Sat"] = "Sat";
    Day["Sun"] = "Sun";
})(Day || (Day = {}));
export var TimeFormat;
(function (TimeFormat) {
    TimeFormat["H12"] = "12";
    TimeFormat["H24"] = "24";
})(TimeFormat || (TimeFormat = {}));
export var ThousandSeparator;
(function (ThousandSeparator) {
    ThousandSeparator["space"] = " ";
    ThousandSeparator["dot"] = ".";
    ThousandSeparator["comma"] = ",";
})(ThousandSeparator || (ThousandSeparator = {}));
export var DecimalFormat;
(function (DecimalFormat) {
    DecimalFormat["dot"] = ".";
    DecimalFormat["comma"] = ",";
})(DecimalFormat || (DecimalFormat = {}));
// loosely copied from https://github.com/felixge/node-dateformat
export var DateFormat;
(function (DateFormat) {
    DateFormat["hyphenM"] = "MM-dd-yyyy";
    DateFormat["dotM"] = "MM.dd.yyyy";
    DateFormat["slashM"] = "MM/dd/yyyy";
    DateFormat["iso"] = "yyyy-MM-dd";
    DateFormat["spaceD"] = "dd MMM yyyy";
    DateFormat["hyphenD"] = "dd-MM-yyyy";
    DateFormat["dotD"] = "dd.MM.yyyy";
    DateFormat["slashD"] = "dd/MM/yyyy";
    DateFormat["humanMD"] = "MMM dd, yyyy";
    DateFormat["humanDD"] = "eee, dd MMM yyyy";
    DateFormat["humanDM"] = "eee, MMM dd yyyy";
    DateFormat["shortDM"] = "dd MMM";
    DateFormat["shortMD"] = "MMM dd";
})(DateFormat || (DateFormat = {}));
export var Currency;
(function (Currency) {
    Currency["AED"] = "AED";
    Currency["ARS"] = "ARS";
    Currency["AUD"] = "AUD";
    Currency["BGN"] = "BGN";
    Currency["BRL"] = "BRL";
    Currency["CAD"] = "CAD";
    Currency["CHF"] = "CHF";
    Currency["CLF"] = "CLF";
    Currency["CLP"] = "CLP";
    Currency["CNY"] = "CNY";
    Currency["COP"] = "COP";
    Currency["CRC"] = "CRC";
    Currency["CZK"] = "CZK";
    Currency["DKK"] = "DKK";
    Currency["DOP"] = "DOP";
    Currency["EEK"] = "EEK";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
    Currency["HKD"] = "HKD";
    Currency["HRK"] = "HRK";
    Currency["HUF"] = "HUF";
    Currency["IDR"] = "IDR";
    Currency["ILS"] = "ILS";
    Currency["INR"] = "INR";
    Currency["ISK"] = "ISK";
    Currency["JMD"] = "JMD";
    Currency["JPY"] = "JPY";
    Currency["KRW"] = "KRW";
    Currency["KWD"] = "KWD";
    Currency["LTL"] = "LTL";
    Currency["LVL"] = "LVL";
    Currency["MAD"] = "MAD";
    Currency["MUR"] = "MUR";
    Currency["MXN"] = "MXN";
    Currency["MYR"] = "MYR";
    Currency["NIO"] = "NIO";
    Currency["NOK"] = "NOK";
    Currency["NZD"] = "NZD";
    Currency["PEN"] = "PEN";
    Currency["PHP"] = "PHP";
    Currency["PLN"] = "PLN";
    Currency["RON"] = "RON";
    Currency["RUB"] = "RUB";
    Currency["SAR"] = "SAR";
    Currency["SEK"] = "SEK";
    Currency["SGD"] = "SGD";
    Currency["THB"] = "THB";
    Currency["TRY"] = "TRY";
    Currency["USD"] = "USD";
    Currency["ZAR"] = "ZAR";
})(Currency || (Currency = {}));
export const currencyDic = {
    AED: {
        digits: 2,
        left: true,
        pay: Currency.EUR,
        symbol: 'AED',
    },
    ARS: {
        digits: 2,
        left: true,
        pay: Currency.USD,
        symbol: '$',
    },
    AUD: {
        digits: 2,
        left: true,
        symbol: 'A$',
    },
    BGN: {
        digits: 2,
        left: false,
        symbol: 'лв',
    },
    BRL: {
        digits: 2,
        left: false,
        pay: Currency.USD,
        symbol: 'R$',
    },
    CAD: {
        digits: 2,
        left: true,
        pay: Currency.USD,
        symbol: 'C$',
    },
    CHF: {
        digits: 2,
        left: false,
        symbol: 'CHF',
    },
    CLF: {
        digits: 5,
        left: true,
        pay: Currency.USD,
        symbol: 'UF$',
    },
    CLP: {
        digits: 0,
        left: true,
        pay: Currency.USD,
        symbol: '$',
    },
    CNY: {
        digits: 2,
        left: false,
        symbol: '¥',
    },
    COP: {
        digits: 2,
        left: true,
        pay: Currency.USD,
        symbol: '$',
    },
    CRC: {
        digits: 2,
        left: true,
        pay: Currency.USD,
        symbol: '₡',
    },
    CZK: {
        digits: 2,
        left: false,
        symbol: 'Kč',
    },
    DKK: {
        digits: 2,
        left: false,
        symbol: 'kr',
    },
    DOP: {
        digits: 2,
        left: true,
        symbol: 'RD$',
    },
    EEK: {
        digits: 2,
        left: false,
        symbol: 'kr',
    },
    EUR: {
        digits: 2,
        left: false,
        symbol: '€',
    },
    GBP: {
        digits: 2,
        left: true,
        symbol: '£',
    },
    HKD: {
        digits: 2,
        left: true,
        symbol: '$HKD',
    },
    HRK: {
        digits: 2,
        left: false,
        symbol: 'kn',
    },
    HUF: {
        digits: 2,
        left: false,
        symbol: 'ft',
    },
    IDR: {
        digits: 0,
        left: false,
        symbol: 'Rp',
    },
    ILS: {
        digits: 2,
        left: true,
        symbol: '₪ ',
    },
    INR: {
        digits: 2,
        left: false,
        symbol: '₨',
    },
    ISK: {
        digits: 0,
        left: false,
        symbol: 'kr',
    },
    JMD: {
        digits: 2,
        left: true,
        pay: Currency.USD,
        symbol: '$',
    },
    JPY: {
        digits: 0,
        left: true,
        symbol: '¥',
    },
    KRW: {
        digits: 0,
        left: false,
        symbol: '₩',
    },
    KWD: {
        digits: 3,
        left: true,
        symbol: 'KD',
    },
    LTL: {
        digits: 2,
        left: false,
        symbol: 'Lt',
    },
    LVL: {
        digits: 2,
        left: false,
        symbol: 'Ls',
    },
    MAD: {
        digits: 2,
        left: false,
        symbol: 'DH',
    },
    MUR: {
        digits: 2,
        left: false,
        pay: Currency.MUR,
        symbol: 'Rs',
    },
    MXN: {
        digits: 2,
        left: true,
        pay: Currency.USD,
        symbol: '$',
    },
    MYR: {
        digits: 2,
        left: false,
        symbol: 'RM',
    },
    NIO: {
        digits: 2,
        left: true,
        pay: Currency.USD,
        symbol: 'C$',
    },
    NOK: {
        digits: 2,
        left: false,
        symbol: 'kr',
    },
    NZD: {
        digits: 2,
        left: true,
        symbol: '$',
    },
    PEN: {
        digits: 2,
        left: true,
        symbol: 'S/',
    },
    PHP: {
        digits: 2,
        left: false,
        symbol: 'Php',
    },
    PLN: {
        digits: 2,
        left: false,
        symbol: 'zł',
    },
    RON: {
        digits: 2,
        left: false,
        symbol: 'lei',
    },
    RUB: {
        digits: 2,
        left: false,
        symbol: 'руб',
    },
    SAR: {
        digits: 2,
        left: true,
        pay: Currency.EUR,
        symbol: 'SAR',
    },
    SEK: {
        digits: 2,
        left: false,
        symbol: 'kr',
    },
    SGD: {
        digits: 2,
        left: true,
        symbol: 'S$ ',
    },
    THB: {
        digits: 2,
        left: false,
        symbol: '฿',
    },
    TRY: {
        digits: 2,
        left: false,
        symbol: 'TL',
    },
    USD: {
        digits: 2,
        left: true,
        symbol: '$',
    },
    ZAR: {
        digits: 2,
        left: true,
        symbol: 'R',
    },
};
export const currencies = Object.keys(currencyDic);
export var Country;
(function (Country) {
    Country["AD"] = "AD";
    Country["AE"] = "AE";
    Country["AF"] = "AF";
    Country["AG"] = "AG";
    Country["AI"] = "AI";
    Country["AL"] = "AL";
    Country["AM"] = "AM";
    Country["AN"] = "AN";
    Country["AO"] = "AO";
    Country["AQ"] = "AQ";
    Country["AR"] = "AR";
    Country["AS"] = "AS";
    Country["AT"] = "AT";
    Country["AU"] = "AU";
    Country["AW"] = "AW";
    Country["AX"] = "AX";
    Country["AZ"] = "AZ";
    Country["BA"] = "BA";
    Country["BB"] = "BB";
    Country["BD"] = "BD";
    Country["BE"] = "BE";
    Country["BF"] = "BF";
    Country["BG"] = "BG";
    Country["BH"] = "BH";
    Country["BI"] = "BI";
    Country["BJ"] = "BJ";
    Country["BL"] = "BL";
    Country["BM"] = "BM";
    Country["BN"] = "BN";
    Country["BO"] = "BO";
    Country["BR"] = "BR";
    Country["BS"] = "BS";
    Country["BT"] = "BT";
    Country["BV"] = "BV";
    Country["BW"] = "BW";
    Country["BY"] = "BY";
    Country["BZ"] = "BZ";
    Country["CA"] = "CA";
    Country["CC"] = "CC";
    Country["CD"] = "CD";
    Country["CF"] = "CF";
    Country["CG"] = "CG";
    Country["CH"] = "CH";
    Country["CI"] = "CI";
    Country["CK"] = "CK";
    Country["CL"] = "CL";
    Country["CM"] = "CM";
    Country["CN"] = "CN";
    Country["CO"] = "CO";
    Country["CR"] = "CR";
    Country["CU"] = "CU";
    Country["CV"] = "CV";
    Country["CX"] = "CX";
    Country["CY"] = "CY";
    Country["CZ"] = "CZ";
    Country["DE"] = "DE";
    Country["DJ"] = "DJ";
    Country["DK"] = "DK";
    Country["DM"] = "DM";
    Country["DO"] = "DO";
    Country["DZ"] = "DZ";
    Country["EC"] = "EC";
    Country["EE"] = "EE";
    Country["EG"] = "EG";
    Country["EH"] = "EH";
    Country["ER"] = "ER";
    Country["ES"] = "ES";
    Country["ET"] = "ET";
    Country["FI"] = "FI";
    Country["FJ"] = "FJ";
    Country["FK"] = "FK";
    Country["FM"] = "FM";
    Country["FO"] = "FO";
    Country["FR"] = "FR";
    Country["GA"] = "GA";
    Country["GB"] = "GB";
    Country["GD"] = "GD";
    Country["GE"] = "GE";
    Country["GF"] = "GF";
    Country["GG"] = "GG";
    Country["GH"] = "GH";
    Country["GI"] = "GI";
    Country["GL"] = "GL";
    Country["GM"] = "GM";
    Country["GN"] = "GN";
    Country["GP"] = "GP";
    Country["GQ"] = "GQ";
    Country["GR"] = "GR";
    Country["GS"] = "GS";
    Country["GT"] = "GT";
    Country["GU"] = "GU";
    Country["GW"] = "GW";
    Country["GY"] = "GY";
    Country["HK"] = "HK";
    Country["HM"] = "HM";
    Country["HN"] = "HN";
    Country["HR"] = "HR";
    Country["HT"] = "HT";
    Country["HU"] = "HU";
    Country["ID"] = "ID";
    Country["IE"] = "IE";
    Country["IL"] = "IL";
    Country["IM"] = "IM";
    Country["IN"] = "IN";
    Country["IO"] = "IO";
    Country["IQ"] = "IQ";
    Country["IR"] = "IR";
    Country["IS"] = "IS";
    Country["IT"] = "IT";
    Country["JE"] = "JE";
    Country["JM"] = "JM";
    Country["JO"] = "JO";
    Country["JP"] = "JP";
    Country["KE"] = "KE";
    Country["KG"] = "KG";
    Country["KH"] = "KH";
    Country["KI"] = "KI";
    Country["KM"] = "KM";
    Country["KN"] = "KN";
    Country["KP"] = "KP";
    Country["KR"] = "KR";
    Country["KW"] = "KW";
    Country["KY"] = "KY";
    Country["KZ"] = "KZ";
    Country["LA"] = "LA";
    Country["LB"] = "LB";
    Country["LC"] = "LC";
    Country["LI"] = "LI";
    Country["LK"] = "LK";
    Country["LR"] = "LR";
    Country["LS"] = "LS";
    Country["LT"] = "LT";
    Country["LU"] = "LU";
    Country["LV"] = "LV";
    Country["LY"] = "LY";
    Country["MA"] = "MA";
    Country["MC"] = "MC";
    Country["MD"] = "MD";
    Country["ME"] = "ME";
    Country["MF"] = "MF";
    Country["MG"] = "MG";
    Country["MH"] = "MH";
    Country["MK"] = "MK";
    Country["ML"] = "ML";
    Country["MM"] = "MM";
    Country["MN"] = "MN";
    Country["MO"] = "MO";
    Country["MP"] = "MP";
    Country["MQ"] = "MQ";
    Country["MR"] = "MR";
    Country["MS"] = "MS";
    Country["MT"] = "MT";
    Country["MU"] = "MU";
    Country["MV"] = "MV";
    Country["MW"] = "MW";
    Country["MX"] = "MX";
    Country["MY"] = "MY";
    Country["MZ"] = "MZ";
    Country["NA"] = "NA";
    Country["NC"] = "NC";
    Country["NE"] = "NE";
    Country["NF"] = "NF";
    Country["NG"] = "NG";
    Country["NI"] = "NI";
    Country["NL"] = "NL";
    Country["NO"] = "NO";
    Country["NP"] = "NP";
    Country["NR"] = "NR";
    Country["NU"] = "NU";
    Country["NZ"] = "NZ";
    Country["OM"] = "OM";
    Country["PA"] = "PA";
    Country["PE"] = "PE";
    Country["PF"] = "PF";
    Country["PG"] = "PG";
    Country["PH"] = "PH";
    Country["PK"] = "PK";
    Country["PL"] = "PL";
    Country["PM"] = "PM";
    Country["PN"] = "PN";
    Country["PR"] = "PR";
    Country["PS"] = "PS";
    Country["PT"] = "PT";
    Country["PW"] = "PW";
    Country["PY"] = "PY";
    Country["QA"] = "QA";
    Country["RE"] = "RE";
    Country["RO"] = "RO";
    Country["RS"] = "RS";
    Country["RU"] = "RU";
    Country["RW"] = "RW";
    Country["SA"] = "SA";
    Country["SB"] = "SB";
    Country["SC"] = "SC";
    Country["SD"] = "SD";
    Country["SE"] = "SE";
    Country["SG"] = "SG";
    Country["SH"] = "SH";
    Country["SI"] = "SI";
    Country["SJ"] = "SJ";
    Country["SK"] = "SK";
    Country["SL"] = "SL";
    Country["SM"] = "SM";
    Country["SN"] = "SN";
    Country["SO"] = "SO";
    Country["SR"] = "SR";
    Country["ST"] = "ST";
    Country["SV"] = "SV";
    Country["SY"] = "SY";
    Country["SZ"] = "SZ";
    Country["TC"] = "TC";
    Country["TD"] = "TD";
    Country["TF"] = "TF";
    Country["TG"] = "TG";
    Country["TH"] = "TH";
    Country["TJ"] = "TJ";
    Country["TK"] = "TK";
    Country["TL"] = "TL";
    Country["TM"] = "TM";
    Country["TN"] = "TN";
    Country["TO"] = "TO";
    Country["TR"] = "TR";
    Country["TT"] = "TT";
    Country["TV"] = "TV";
    Country["TW"] = "TW";
    Country["TZ"] = "TZ";
    Country["UA"] = "UA";
    Country["UG"] = "UG";
    Country["UM"] = "UM";
    Country["US"] = "US";
    Country["UY"] = "UY";
    Country["UZ"] = "UZ";
    Country["VA"] = "VA";
    Country["VC"] = "VC";
    Country["VE"] = "VE";
    Country["VG"] = "VG";
    Country["VI"] = "VI";
    Country["VN"] = "VN";
    Country["VU"] = "VU";
    Country["WF"] = "WF";
    Country["WS"] = "WS";
    Country["YE"] = "YE";
    Country["YT"] = "YT";
    Country["ZA"] = "ZA";
    Country["ZM"] = "ZM";
    Country["ZW"] = "ZW";
})(Country || (Country = {}));
export var TimeZone;
(function (TimeZone) {
    TimeZone["Africa_Cairo"] = "Africa/Cairo";
    TimeZone["Africa_Casablanca"] = "Africa/Casablanca";
    TimeZone["Africa_Johannesburg"] = "Africa/Johannesburg";
    TimeZone["Africa_Lagos"] = "Africa/Lagos";
    TimeZone["Africa_Nairobi"] = "Africa/Nairobi";
    TimeZone["Africa_Windhoek"] = "Africa/Windhoek";
    TimeZone["America_Anchorage"] = "America/Anchorage";
    TimeZone["America_Asuncion"] = "America/Asuncion";
    TimeZone["America_Bogota"] = "America/Bogota";
    TimeZone["America_Buenos_Aires"] = "America/Buenos_Aires";
    TimeZone["America_Caracas"] = "America/Caracas";
    TimeZone["America_Cayenne"] = "America/Cayenne";
    TimeZone["America_Chicago"] = "America/Chicago";
    TimeZone["America_Cuiaba"] = "America/Cuiaba";
    TimeZone["America_Godthab"] = "America/Godthab";
    TimeZone["America_Guatemala"] = "America/Guatemala";
    TimeZone["America_Halifax"] = "America/Halifax";
    TimeZone["America_La_Paz"] = "America/La_Paz";
    TimeZone["America_Los_Angeles"] = "America/Los_Angeles";
    TimeZone["America_Montevideo"] = "America/Montevideo";
    TimeZone["America_New_York"] = "America/New_York";
    TimeZone["America_Phoenix"] = "America/Phoenix";
    TimeZone["America_Santiago"] = "America/Santiago";
    TimeZone["America_Sao_Paulo"] = "America/Sao_Paulo";
    TimeZone["America_St_Johns"] = "America/St_Johns";
    TimeZone["Asia_Almaty"] = "Asia/Almaty";
    TimeZone["Asia_Amman"] = "Asia/Amman";
    TimeZone["Asia_Baghdad"] = "Asia/Baghdad";
    TimeZone["Asia_Baku"] = "Asia/Baku";
    TimeZone["Asia_Bangkok"] = "Asia/Bangkok";
    TimeZone["Asia_Beirut"] = "Asia/Beirut";
    TimeZone["Asia_Calcutta"] = "Asia/Calcutta";
    TimeZone["Asia_Colombo"] = "Asia/Colombo";
    TimeZone["Asia_Dubai"] = "Asia/Dubai";
    TimeZone["Asia_Irkutsk"] = "Asia/Irkutsk";
    TimeZone["Asia_Jerusalem"] = "Asia/Jerusalem";
    TimeZone["Asia_Kabul"] = "Asia/Kabul";
    TimeZone["Asia_Kamchatka"] = "Asia/Kamchatka";
    TimeZone["Asia_Karachi"] = "Asia/Karachi";
    TimeZone["Asia_Katmandu"] = "Asia/Katmandu";
    TimeZone["Asia_Krasnoyarsk"] = "Asia/Krasnoyarsk";
    TimeZone["Asia_Novosibirsk"] = "Asia/Novosibirsk";
    TimeZone["Asia_Rangoon"] = "Asia/Rangoon";
    TimeZone["Asia_Seoul"] = "Asia/Seoul";
    TimeZone["Asia_Shanghai"] = "Asia/Shanghai";
    TimeZone["Asia_Singapore"] = "Asia/Singapore";
    TimeZone["Asia_Taipei"] = "Asia/Taipei";
    TimeZone["Asia_Tashkent"] = "Asia/Tashkent";
    TimeZone["Asia_Tbilisi"] = "Asia/Tbilisi";
    TimeZone["Asia_Tehran"] = "Asia/Tehran";
    TimeZone["Asia_Tokyo"] = "Asia/Tokyo";
    TimeZone["Asia_Yekaterinburg"] = "Asia/Yekaterinburg";
    TimeZone["Asia_Yerevan"] = "Asia/Yerevan";
    TimeZone["Atlantic_Azores"] = "Atlantic/Azores";
    TimeZone["Atlantic_Cape_Verde"] = "Atlantic/Cape_Verde";
    TimeZone["Atlantic_Reykjavik"] = "Atlantic/Reykjavik";
    TimeZone["Australia_Brisbane"] = "Australia/Brisbane";
    TimeZone["Australia_Darwin"] = "Australia/Darwin";
    TimeZone["Australia_Perth"] = "Australia/Perth";
    TimeZone["Australia_Sydney"] = "Australia/Sydney";
    TimeZone["Europe_Berlin"] = "Europe/Berlin";
    TimeZone["Europe_Budapest"] = "Europe/Budapest";
    TimeZone["Europe_Istanbul"] = "Europe/Istanbul";
    TimeZone["Europe_Kiev"] = "Europe/Kiev";
    TimeZone["Europe_London"] = "Europe/London";
    TimeZone["Europe_Minsk"] = "Europe/Minsk";
    TimeZone["Europe_Moscow"] = "Europe/Moscow";
    TimeZone["Indian_Mauritius"] = "Indian/Mauritius";
    TimeZone["Pacific_Apia"] = "Pacific/Apia";
    TimeZone["Pacific_Auckland"] = "Pacific/Auckland";
    TimeZone["Pacific_Fiji"] = "Pacific/Fiji";
    TimeZone["Pacific_Guadalcanal"] = "Pacific/Guadalcanal";
    TimeZone["Pacific_Honolulu"] = "Pacific/Honolulu";
    TimeZone["Pacific_Port_Moresby"] = "Pacific/Port_Moresby";
    TimeZone["Pacific_Tongatapu"] = "Pacific/Tongatapu";
    TimeZone["UTC"] = "UTC";
})(TimeZone || (TimeZone = {}));
export const timeZoneLabel = {
    [TimeZone.Africa_Cairo]: 'Egypt',
    [TimeZone.Africa_Casablanca]: 'Morocco',
    [TimeZone.Africa_Johannesburg]: 'South Africa',
    [TimeZone.Africa_Lagos]: 'Western Central Africa',
    [TimeZone.Africa_Nairobi]: 'Eastern Africa',
    [TimeZone.Africa_Windhoek]: 'Namibia',
    [TimeZone.America_Anchorage]: 'Alaskan',
    [TimeZone.America_Asuncion]: 'Paraguay',
    [TimeZone.America_Bogota]: 'South America Pacific',
    [TimeZone.America_Buenos_Aires]: 'Argentina',
    [TimeZone.America_Caracas]: 'Venezuela',
    [TimeZone.America_Cayenne]: 'South America Eastern',
    [TimeZone.America_Chicago]: 'Central Standard Time',
    [TimeZone.America_Cuiaba]: 'Central Brazilian',
    [TimeZone.America_Godthab]: 'Greenland',
    [TimeZone.America_Guatemala]: 'Central Pacific',
    [TimeZone.America_Halifax]: 'Atlantic Standard Time',
    [TimeZone.America_La_Paz]: 'South America Western',
    [TimeZone.America_Los_Angeles]: 'Pacific Standard Time',
    [TimeZone.America_Montevideo]: 'Montevideo',
    [TimeZone.America_New_York]: 'Eastern Standard Time',
    [TimeZone.America_Phoenix]: 'Mountain Standard Time',
    [TimeZone.America_Santiago]: 'South America Pacific',
    [TimeZone.America_Sao_Paulo]: 'Eastern South America',
    [TimeZone.America_St_Johns]: 'Newfoundland',
    [TimeZone.Asia_Almaty]: 'Central Asia',
    [TimeZone.Asia_Amman]: 'Jordan',
    [TimeZone.Asia_Baghdad]: 'Arabic',
    [TimeZone.Asia_Baku]: 'Azerbaijan',
    [TimeZone.Asia_Bangkok]: 'South Eastern Asia',
    [TimeZone.Asia_Beirut]: 'Middle East',
    [TimeZone.Asia_Calcutta]: 'India',
    [TimeZone.Asia_Colombo]: 'Sri Lanka',
    [TimeZone.Asia_Dubai]: 'Arabian',
    [TimeZone.Asia_Irkutsk]: 'North Eastern Asia',
    [TimeZone.Asia_Jerusalem]: 'Israel',
    [TimeZone.Asia_Kabul]: 'Afghanistan',
    [TimeZone.Asia_Kamchatka]: 'Kamchatka',
    [TimeZone.Asia_Karachi]: 'Pakistan',
    [TimeZone.Asia_Katmandu]: 'Nepal',
    [TimeZone.Asia_Krasnoyarsk]: 'North Asia',
    [TimeZone.Asia_Novosibirsk]: 'Northern Central Asia',
    [TimeZone.Asia_Rangoon]: 'Myanmar',
    [TimeZone.Asia_Seoul]: 'Korea',
    [TimeZone.Asia_Shanghai]: 'China',
    [TimeZone.Asia_Singapore]: 'Singapore',
    [TimeZone.Asia_Taipei]: 'Taipei',
    [TimeZone.Asia_Tashkent]: 'Western Asia',
    [TimeZone.Asia_Tbilisi]: 'Georgian',
    [TimeZone.Asia_Tehran]: 'Iran',
    [TimeZone.Asia_Tokyo]: 'Tokyo',
    [TimeZone.Asia_Yekaterinburg]: 'Ekaterinburg',
    [TimeZone.Asia_Yerevan]: 'Caucasus',
    [TimeZone.Atlantic_Azores]: 'Azores',
    [TimeZone.Atlantic_Cape_Verde]: 'Cape Verde',
    [TimeZone.Atlantic_Reykjavik]: 'Greenwich, Reykjavik',
    [TimeZone.Australia_Brisbane]: 'Eastern Australia Brisbane',
    [TimeZone.Australia_Darwin]: 'Australia Central',
    [TimeZone.Australia_Perth]: 'Western Australia',
    [TimeZone.Australia_Sydney]: 'Eastern Australia Sydney',
    [TimeZone.Europe_Berlin]: 'Western Europe',
    [TimeZone.Europe_Budapest]: 'Central Europe',
    [TimeZone.Europe_Istanbul]: 'Greece, Turkey, Belarus',
    [TimeZone.Europe_Kiev]: 'Further-eastern Europe',
    [TimeZone.Europe_London]: 'London',
    [TimeZone.Europe_Minsk]: 'Eastern Europe',
    [TimeZone.Europe_Moscow]: 'Russian',
    [TimeZone.Indian_Mauritius]: 'Mauritius',
    [TimeZone.Pacific_Apia]: 'Samoa',
    [TimeZone.Pacific_Auckland]: 'New Zealand',
    [TimeZone.Pacific_Fiji]: 'Fiji',
    [TimeZone.Pacific_Guadalcanal]: 'Central Pacific',
    [TimeZone.Pacific_Honolulu]: 'Hawaiian',
    [TimeZone.Pacific_Port_Moresby]: 'West Pacific',
    [TimeZone.Pacific_Tongatapu]: 'Tonga',
    [TimeZone.UTC]: 'GMT, UTC',
};
export const localisationDic = {
    AD: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    AE: {
        currency: Currency.AED,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    AF: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Kabul,
        firstDayOfWeek: 1,
    },
    AG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    AI: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    AL: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    AM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    AN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    AO: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    AQ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Guadalcanal,
        firstDayOfWeek: 1,
    },
    AR: {
        currency: Currency.ARS,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    AS: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Apia,
        firstDayOfWeek: 1,
    },
    AT: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    AU: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Australia_Darwin,
        firstDayOfWeek: 1,
    },
    AW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    AX: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    AZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    BA: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    BB: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    BD: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Asia_Almaty,
        firstDayOfWeek: 1,
    },
    BE: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    BF: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    BG: {
        currency: Currency.BGN,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    BH: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    BI: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    BJ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    BL: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    BM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    BN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    BO: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    BR: {
        currency: Currency.BRL,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    BS: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    BT: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Almaty,
        firstDayOfWeek: 1,
    },
    BV: {
        currency: Currency.NOK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    BW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    BY: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    BZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Guatemala,
        firstDayOfWeek: 1,
    },
    CA: {
        currency: Currency.CAD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    CC: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Rangoon,
        firstDayOfWeek: 1,
    },
    CD: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    CF: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    CG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    CH: {
        currency: Currency.CHF,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    CI: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    CK: {
        currency: Currency.NZD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Honolulu,
        firstDayOfWeek: 1,
    },
    CL: {
        currency: Currency.CLP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    CM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    CN: {
        currency: Currency.CNY,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    CO: {
        currency: Currency.COP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    CR: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Guatemala,
        firstDayOfWeek: 1,
    },
    CU: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    CV: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Atlantic_Azores,
        firstDayOfWeek: 1,
    },
    CX: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Bangkok,
        firstDayOfWeek: 1,
    },
    CY: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    CZ: {
        currency: Currency.CZK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    DE: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    DJ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    DK: {
        currency: Currency.DKK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    DM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    DO: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    DZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    EC: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    EE: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    EG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    EH: {
        currency: Currency.MAD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    ER: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    ES: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    ET: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    FI: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    FJ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Kamchatka,
        firstDayOfWeek: 1,
    },
    FK: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    FM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Australia_Brisbane,
        firstDayOfWeek: 1,
    },
    FO: {
        currency: Currency.DKK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    FR: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    GA: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    GB: {
        currency: Currency.GBP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    GD: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    GE: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    GF: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    GG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    GH: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    GI: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    GL: {
        currency: Currency.DKK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    GM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    GN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    GP: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    GQ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    GR: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    GS: {
        currency: Currency.GBP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Atlantic_Azores,
        firstDayOfWeek: 1,
    },
    GT: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Guatemala,
        firstDayOfWeek: 1,
    },
    GU: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Australia_Brisbane,
        firstDayOfWeek: 1,
    },
    GW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    GY: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    HK: {
        currency: Currency.HKD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    HM: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Karachi,
        firstDayOfWeek: 1,
    },
    HN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Guatemala,
        firstDayOfWeek: 1,
    },
    HR: {
        currency: Currency.HRK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    HT: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    HU: {
        currency: Currency.HUF,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    ID: {
        currency: Currency.IDR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Bangkok,
        firstDayOfWeek: 1,
    },
    IE: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    IL: {
        currency: Currency.ILS,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    IM: {
        currency: Currency.GBP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    IN: {
        currency: Currency.INR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Asia_Colombo,
        firstDayOfWeek: 1,
    },
    IO: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Almaty,
        firstDayOfWeek: 1,
    },
    IQ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    IR: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tehran,
        firstDayOfWeek: 1,
    },
    IS: {
        currency: Currency.ISK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    IT: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    JE: {
        currency: Currency.GBP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    JM: {
        currency: Currency.JMD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    JO: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    JP: {
        currency: Currency.JPY,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tokyo,
        firstDayOfWeek: 1,
    },
    KE: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    KG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Almaty,
        firstDayOfWeek: 1,
    },
    KH: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Bangkok,
        firstDayOfWeek: 1,
    },
    KI: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Apia,
        firstDayOfWeek: 1,
    },
    KM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    KN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    KP: {
        currency: Currency.KRW,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tokyo,
        firstDayOfWeek: 1,
    },
    KR: {
        currency: Currency.KRW,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tokyo,
        firstDayOfWeek: 1,
    },
    KW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    KY: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    KZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Almaty,
        firstDayOfWeek: 1,
    },
    LA: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Bangkok,
        firstDayOfWeek: 1,
    },
    LB: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    LC: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    LI: {
        currency: Currency.CHF,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    LK: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Colombo,
        firstDayOfWeek: 1,
    },
    LR: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    LS: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    LT: {
        currency: Currency.LTL,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    LU: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    LV: {
        currency: Currency.LVL,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    LY: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    MA: {
        currency: Currency.MAD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    MC: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    MD: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    ME: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    MF: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    MG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    MH: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Kamchatka,
        firstDayOfWeek: 1,
    },
    MK: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    ML: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    MM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Rangoon,
        firstDayOfWeek: 1,
    },
    MN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    MO: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    MP: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Australia_Brisbane,
        firstDayOfWeek: 1,
    },
    MQ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    MR: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    MS: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    MT: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    MU: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    MV: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Karachi,
        firstDayOfWeek: 1,
    },
    MW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    MX: {
        currency: Currency.MXN,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.America_Guatemala,
        firstDayOfWeek: 1,
    },
    MY: {
        currency: Currency.MYR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    MZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    NA: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    NC: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Guadalcanal,
        firstDayOfWeek: 1,
    },
    NE: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    NF: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Auckland,
        firstDayOfWeek: 1,
    },
    NG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    NI: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Guatemala,
        firstDayOfWeek: 1,
    },
    NL: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    NO: {
        currency: Currency.NOK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    NP: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Katmandu,
        firstDayOfWeek: 1,
    },
    NR: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Kamchatka,
        firstDayOfWeek: 1,
    },
    NU: {
        currency: Currency.NZD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Apia,
        firstDayOfWeek: 1,
    },
    NZ: {
        currency: Currency.NZD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Asia_Kamchatka,
        firstDayOfWeek: 1,
    },
    OM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    PA: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    PE: {
        currency: Currency.PEN,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    PF: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Anchorage,
        firstDayOfWeek: 1,
    },
    PG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Australia_Brisbane,
        firstDayOfWeek: 1,
    },
    PH: {
        currency: Currency.PHP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    PK: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Asia_Karachi,
        firstDayOfWeek: 1,
    },
    PL: {
        currency: Currency.PLN,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    PM: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    PN: {
        currency: Currency.PHP,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Los_Angeles,
        firstDayOfWeek: 1,
    },
    PR: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    PS: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    PT: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Atlantic_Azores,
        firstDayOfWeek: 1,
    },
    PW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tokyo,
        firstDayOfWeek: 1,
    },
    PY: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    QA: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    RE: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    RO: {
        currency: Currency.RON,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    RS: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    RU: {
        currency: Currency.RUB,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Moscow,
        firstDayOfWeek: 1,
    },
    RW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    SA: {
        currency: Currency.SAR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    SB: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Guadalcanal,
        firstDayOfWeek: 1,
    },
    SC: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tbilisi,
        firstDayOfWeek: 1,
    },
    SD: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    SE: {
        currency: Currency.SEK,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    SG: {
        currency: Currency.SGD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    SH: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    SI: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    SJ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    SK: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    SL: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    SM: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    SN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    SO: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    SR: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    ST: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    SV: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Guatemala,
        firstDayOfWeek: 1,
    },
    SY: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    SZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    TC: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_New_York,
        firstDayOfWeek: 1,
    },
    TD: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    TF: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Karachi,
        firstDayOfWeek: 1,
    },
    TG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_London,
        firstDayOfWeek: 1,
    },
    TH: {
        currency: Currency.THB,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Bangkok,
        firstDayOfWeek: 1,
    },
    TJ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Karachi,
        firstDayOfWeek: 1,
    },
    TK: {
        currency: Currency.NZD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Apia,
        firstDayOfWeek: 1,
    },
    TL: {
        currency: Currency.THB,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Tokyo,
        firstDayOfWeek: 1,
    },
    TM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Karachi,
        firstDayOfWeek: 1,
    },
    TN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    TO: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Apia,
        firstDayOfWeek: 1,
    },
    TR: {
        currency: Currency.TRY,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    TT: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    TV: {
        currency: Currency.AUD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Kamchatka,
        firstDayOfWeek: 1,
    },
    TW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Taipei,
        firstDayOfWeek: 1,
    },
    TZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    UA: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    UG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    UM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.Pacific_Honolulu,
        firstDayOfWeek: 0,
    },
    US: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.America_Los_Angeles,
        firstDayOfWeek: 0,
    },
    UY: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Santiago,
        firstDayOfWeek: 1,
    },
    UZ: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Karachi,
        firstDayOfWeek: 1,
    },
    VA: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Berlin,
        firstDayOfWeek: 1,
    },
    VC: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    VE: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_Caracas,
        firstDayOfWeek: 1,
    },
    VG: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    VI: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H12,
        timeZone: TimeZone.America_La_Paz,
        firstDayOfWeek: 1,
    },
    VN: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Bangkok,
        firstDayOfWeek: 1,
    },
    VU: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Guadalcanal,
        firstDayOfWeek: 1,
    },
    WF: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Asia_Kamchatka,
        firstDayOfWeek: 1,
    },
    WS: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Pacific_Apia,
        firstDayOfWeek: 1,
    },
    YE: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    YT: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Minsk,
        firstDayOfWeek: 1,
    },
    ZA: {
        currency: Currency.ZAR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.comma,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    ZM: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    ZW: {
        currency: Currency.USD,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.space,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.Europe_Istanbul,
        firstDayOfWeek: 1,
    },
    default: {
        currency: Currency.EUR,
        dateFormat: DateFormat.humanDD,
        decimalFormat: DecimalFormat.dot,
        thousandSeparator: ThousandSeparator.comma,
        timeFormat: TimeFormat.H24,
        timeZone: TimeZone.UTC,
        firstDayOfWeek: 1,
    },
};
//# sourceMappingURL=localisation.js.map